import React from 'react'
import CommentsLayout from './CommentsLayout'

const Comments = () => {
  return <CommentsLayout />
}

export default Comments
